/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchProviderDirectoryResponse } from './SearchProviderDirectoryResponse';
import {
    SearchProviderDirectoryResponseFromJSON,
    SearchProviderDirectoryResponseFromJSONTyped,
    SearchProviderDirectoryResponseToJSON,
} from './SearchProviderDirectoryResponse';

/**
 * 
 * @export
 * @interface SearchProviderDirectory200Response
 */
export interface SearchProviderDirectory200Response {
    /**
     * 
     * @type {SearchProviderDirectoryResponse}
     * @memberof SearchProviderDirectory200Response
     */
    data?: SearchProviderDirectoryResponse;
}

/**
 * Check if a given object implements the SearchProviderDirectory200Response interface.
 */
export function instanceOfSearchProviderDirectory200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchProviderDirectory200ResponseFromJSON(json: any): SearchProviderDirectory200Response {
    return SearchProviderDirectory200ResponseFromJSONTyped(json, false);
}

export function SearchProviderDirectory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProviderDirectory200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SearchProviderDirectoryResponseFromJSON(json['data']),
    };
}

export function SearchProviderDirectory200ResponseToJSON(value?: SearchProviderDirectory200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SearchProviderDirectoryResponseToJSON(value.data),
    };
}

